import React, { useEffect, useState } from "react";
import { FaCalendarPlus, FaMessage, FaTrash } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import AgendarCita from "./FormularioCita";
import NuevoMensaje from "./NuevoMensaje";
import "../css/TarjetaUsuario.css";
import { confirmToast } from "../toast/confirmToast";
import { API_BASE_URL } from "../../config/apiConfig";
import { toast } from "react-toastify";

const TarjetaUsuario = ({ user, token, onDeleted }) => {
  const [agendarCita, setAgendarCita] = useState(false);
  const [mostrarMensaje, setMostrarMensaje] = useState(false);
  const [imagenSrc, setImagenSrc] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [isDeletingModalOpen, setIsDeletingModalOpen] = useState(false);

  const navigate = useNavigate();

  // Imagen por defecto
  const imagenPorDefecto =
    "https://static.vecteezy.com/system/resources/previews/036/280/651/non_2x/default-avatar-profile-icon-social-media-user-image-gray-avatar-icon-blank-profile-silhouette-illustration-vector.jpg";
  useEffect(() => {
    const cargarImagen = async () => {
      // Si no hay foto del usuario o no hay tempFoto, usar imagen por defecto
      // if (!user.foto) {
      //   setImagenSrc(imagenPorDefecto);
      //   return;
      // }

      try {
        // Si hay token, hacer petición autenticada
        if (token) {
          const response = await fetch(user.foto, {
            headers: {
              "x-auth-token": token,
            },
          });

          if (response.ok) {
            const blob = await response.blob();
            const imageObjectURL = URL.createObjectURL(blob);
            setImagenSrc(imageObjectURL);
          } else {
            // Si falla la carga, usar imagen por defecto
            setImagenSrc(imagenPorDefecto);
          }
        } else {
          // Si no hay token, intentar cargar directamente (por si es una URL pública)
          setImagenSrc(user.foto);
        }
      } catch (error) {
        console.error("Error al cargar imagen:", error);
        setImagenSrc(imagenPorDefecto);
      }
    };

    cargarImagen();

    // Cleanup: revocar URL del objeto cuando el componente se desmonte
    return () => {
      if (imagenSrc && imagenSrc.startsWith("blob:")) {
        URL.revokeObjectURL(imagenSrc);
      }
    };
  }, [user.foto, token]);

  // Funcion para confirmar la eliminación del usuario
  async function handleUserDelete(e, id) {
    e.preventDefault();
    if (isDeletingModalOpen) return;
    setIsDeletingModalOpen(true);
    const ok = await confirmToast({
      title: `¿Eliminar la cuenta de ${user?.name ?? user?.email}?`,
      message: `Esta acción es irreversible. Se borrarán perfil, sesiones, archivos y demás datos asociados. `,
      confirmText: "Eliminar cuenta",
      cancelText: "Cancelar",
    });

    if (!ok) return setIsDeletingModalOpen(false);

    try {
      setIsDeleting(true);
      // optionally show a "loading state" inside the toast

      const res = await fetch(`${API_BASE_URL}/auth/deleteCitizen`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-auth-token": token, // si tu server lo permite
        },
        body: JSON.stringify({ userId: id }), // usa el id real
      });
      if (!res.ok) {
        throw new Error("Error al eliminar el usuario");
      }
      toast.success("Usuario eliminado Correctamente");
      onDeleted?.(id);
      // navigate("/admin/usuarios");
    } catch (e) {
      toast.error("No se pudo eliminar el usuario intenta más tarde");
    } finally {
      setIsDeletingModalOpen(false);
      setIsDeleting(false);
    }
  }

  if (!user) return null;

  return (
    <>
      <Link to={`/admin/usuario/${user.id}`} className="tarjeta-usuario flex negro" aria-label={`${user.nombre} ${user.apellido}`}>
        <img src={imagenSrc || imagenPorDefecto} alt={`${user.nombre} ${user.apellido}`} onError={() => setImagenSrc(imagenPorDefecto)} />
        <div className="datos">
          <div className="informacion column">
            <p className="nombre bold font-18">
              {user.nombre} {user.apellido}
            </p>
            <p>{user.dni}</p>
            <p className=" mt-10">{user.estadoLaboral}</p>
            <div className="align-center">
              <div className={`estado align-center ${user.estado.toLowerCase()}`}></div>
              <p>{user.estado}</p>
            </div>
          </div>
          <div className="acciones align-center">
            <button
              onClick={(e) => {
                e.preventDefault();
                setAgendarCita(true);
              }}
              aria-label="Agendar nueva cita"
            >
              <FaCalendarPlus />
            </button>
            {/* <button
              className="mb-[-4px]"
              onClick={(e) => {
                e.preventDefault();
                setMostrarMensaje(true);
              }}
              aria-label="Enviar mensaje"
            >
              <FaMessage />
            </button> */}
            <button
              className={`${isDeletingModalOpen ? "opacity-25 cursor-not-allowed hover:cursor-not-allowed" : ""}`}
              disabled={isDeletingModalOpen}
              onClick={(e) => {
                handleUserDelete(e, user.id);
              }}
              aria-label="Borrar Usuario"
            >
              <FaTrash color="#f44336" />
            </button>
          </div>
        </div>
      </Link>

      {agendarCita && (
        <AgendarCita
          dniPorDefecto={user.dni}
          onClose={() => setAgendarCita(false)}
          onGuardar={(evento) => {
            setAgendarCita(false);
          }}
        />
      )}

      {mostrarMensaje && (
        <NuevoMensaje
          dni={user.dni}
          onClose={() => setMostrarMensaje(false)}
          onEnviar={(mensaje) => {
            setMostrarMensaje(false);
          }}
        />
      )}
    </>
  );
};

export default TarjetaUsuario;
